import 'primeicons/primeicons.css';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.css';
import 'primeflex/primeflex.css';
import HomeView from './HomeView';
import LoginView from './LoginView';
import AboutView from './AboutView';
import CashView from './CashView';
import ImportView from './ImportView';
import AccountView from './AccountView';
import CategoryView from './CategoryView';
import KeywordView from './KeywordView';
import EstimateView from './EstimateView';
import CashFlowView from './CashFlowView';
import WHView from './WHView';
import TestView from './TestView';
import UserView from './UserView';
import GundilerView from './GundilerView';
import UnauthorizedView from './UnauthorizedView';
import { createContext } from "react";
import {BrowserRouter,Route,Routes} from 'react-router-dom';
import ProtectedRoutes from './ProtectedRoutes';

export const UserContext = createContext();

const App = () => {
  
    return (   
        <div>
        <div id="pages">
        
            <BrowserRouter>
                <Routes>
                  <Route path="/login" element={<LoginView/>}/>
                  <Route element={<ProtectedRoutes/>}>
                    <Route path="/cash" element={<CashView/>}/>
                    <Route path="/flow" element={<CashFlowView/>}/>
                    <Route path="/import" element={<ImportView/>}/>
                    <Route path="/account" element={<AccountView/>}/>
                    <Route path="/category" element={<CategoryView/>}/>
                    <Route path="/keyword" element={<KeywordView/>}/>
                    <Route path="/estimate" element={<EstimateView/>}/>
                    <Route path="/gundiler" element={<GundilerView/>}/>
                    <Route path="/wh" element={<WHView/>}/>
                    <Route path="/" element= {<HomeView/>}/>
                    <Route path="/user" element= {<UserView/>}/>
                    <Route path="/about" element={<AboutView/>}/>
                    <Route path="/test" element={<TestView/>}/>
                  </Route>
                    <Route path="/unauthorized" element= {<UnauthorizedView/>}/>
                </Routes>
            </BrowserRouter>
        
        </div>
        </div>
    )
};

export default App;